import autobind from 'core-decorators/lib/autobind';

import { WixConnect } from 'shared/utils/wix-connect';
import getDisplayName from 'shared/utils/get-component-display-name';

import Icon from 'shared/components/icon/icon';
import { GenericButton } from 'shared/components/button/button';

import styles from './strip.styl';


export default function withVideoSelectionButtons(WrappedComponent) {

  @WixConnect(styles)
  class ProvideVideoSelectionButtons extends React.Component {
    static displayName = `ProvideVideoSelectionButtons(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      nextVideoId: React.PropTypes.string,
      prevVideoId: React.PropTypes.string,
      selectNextVideo: React.PropTypes.func,
      selectPrevVideo: React.PropTypes.func,
    };

    static defaultProps = {
      selectNextVideo: _.noop,
      selectPrevVideo: _.noop,
    };

    @autobind
    selectNextVideo(event) {
      event.stopPropagation();

      this.props.selectNextVideo();
    }

    @autobind
    selectPrevVideo(event) {
      event.stopPropagation();

      this.props.selectPrevVideo();
    }

    get prevVideoButton() {
      const { prevVideoId } = this.props;

      if (!prevVideoId) {
        return null;
      }

      return (
        <GenericButton styleName="button prev-button"
                       onClick={this.selectPrevVideo}>
          <Icon styleName="reverse"
                name="arrow-strip" />
        </GenericButton>
      );
    }

    get nextVideoButton() {
      const { nextVideoId } = this.props;

      if (!nextVideoId) {
        return null;
      }

      return (
        <GenericButton styleName="button next-button"
                       onClick={this.selectNextVideo}>
          <Icon name="arrow-strip" />
        </GenericButton>
      );
    }

    render() {
      const props = {
        ...this.props,
        nextVideoButton: this.nextVideoButton,
        prevVideoButton: this.prevVideoButton,
      };
      return (
        <WrappedComponent {...props} />
      );
    }
  }

  return ProvideVideoSelectionButtons;
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/strip/with-video-selection-buttons.js